/* eslint-disable prettier/prettier */
import React from 'react';
import { useSeasons } from '../../../hooks/seasons';

function Standings({
  season,
  setSeason,
  formShow,
  setFormShow,
  standingsType,
  setStandingsType,
  showSeasonSelection,
  isWidget,
}) {
  const [seasons] = useSeasons('desc');
  return (
    <div className="standings-filter">
      {!isWidget ? (
        <div className="standings-filter__button d-none d-md-flex">
          <div
            className="tabs"
            style={{
              width: 300,
              height: 43,
              borderColor: 'var(--comp-color-1)',
            }}
          >
            <div className="row">
              <div className="col-4 pe-0">
                <div
                  onClick={() => setStandingsType('total')}
                  className={`tabs__item tabs__item--small text-uppercase ${
                    standingsType === 'total' ? 'tabs__item--is-active' : ''
                  }`}
                  aria-hidden="true"
                >
                  Totalt
                </div>
              </div>
              <div className="col-4 ps-0">
                <div
                  onClick={() => setStandingsType('home')}
                  className={`tabs__item tabs__item--small text-uppercase ${
                    standingsType === 'home' ? 'tabs__item--is-active' : ''
                  }`}
                  aria-hidden="true"
                >
                  Hemma
                </div>
              </div>
              <div className="col-4 ps-0">
                <div
                  onClick={() => setStandingsType('away')}
                  className={`tabs__item tabs__item--small text-uppercase ${
                    standingsType === 'away' ? 'tabs__item--is-active' : ''
                  }`}
                  aria-hidden="true"
                >
                  Borta
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {showSeasonSelection ? (
        <div className="standings-filter__select">
          <p className="heading-h6 mb-1">Säsong</p>
          <select
            value={season}
            onChange={(e) => setSeason(e.target.value)}
            className="select"
          >
            {seasons?.map((s) => (
              <option
                key={s.configSeasonStartYear}
                value={s?.configSeasonStartYear}
              >
                {Number(s?.configSeasonStartYear) < 1958
                  ? `${s?.configSeasonStartYear}/${
                      Number(String(s?.configSeasonStartYear).slice(2)) + 1
                    }`
                  : `${s?.configSeasonStartYear}`}
              </option>
            ))}
          </select>
        </div>
      ) : null}
      {setFormShow && !isWidget && (
        <div className="standings-filter__button">
          <button
            type="button"
            className="button button--primary d-none d-lg-inline-block text-center"
            onClick={() => (formShow ? setFormShow(false) : setFormShow(true))}
          >
            {formShow ? 'Dölj form' : 'Visa form'}
          </button>
        </div>
      )}
    </div>
  );
}
export default Standings;
